export const SET_BUILD_INFO = 'app/BUILD_INFO';
export const RESET_REDUCERS = 'app/RESET_REDUCERS';
